const invalidPerception = ['022', '023', '025', '039', '044'];

export default {
  subtotal: (state, { total, taxes }) => total + taxes,

  taxes: ({ deductions }) => deductions.reduce(
    (accum, { amount }) => parseFloat(accum) + parseFloat(amount || 0.00),
    0.00,
  ),

  total: ({ percepts, otherPayments }, { taxes }) => {
    const totalPercepts = percepts.reduce(
      (accum, { type, taxedAmount, exemptAmount }) => (
        invalidPerception.includes(type)
          ? accum
          : accum + parseFloat(taxedAmount || 0.00) + parseFloat(exemptAmount || 0.00)
      ),
      0.00,
    );

    const totalOtherPayments = otherPayments.reduce(
      (accum, { amount }) => accum + parseFloat(amount || 0.00),
      0.00,
    );

    const totalPayroll = parseFloat(totalPercepts) + parseFloat(totalOtherPayments);

    return parseFloat(totalPayroll) - parseFloat(taxes);
  },
};
